import ImageCDN from "@components/skeleton/ImageCDN";
import { RaqPageType } from "@components/utils/constants";
import {
  IAccommodationResponse,
  IActivityResponse,
  ILocationResponse,
  IPackageResponse,
  ITagResponse,
} from "@customTypes/modelResponses";
import { useMemo } from "react";
import { ImageDefault } from "../utils/Utils";
import PackageDesktopPhotos from "./PackageDesktopPhotos";

interface IPhotoWithTagsProps {
  isSingle: boolean;
  data:
    | IAccommodationResponse
    | ILocationResponse
    | IPackageResponse
    | IActivityResponse;
  tags: ITagResponse[];
  collectionType: RaqPageType;
}

function PhotoWithTags(props: IPhotoWithTagsProps): JSX.Element {
  const mainImage = useMemo(() => {
    if (props.isSingle) {
      const entryWithMedia = props.data as ILocationResponse &
        IAccommodationResponse &
        IActivityResponse;
      return entryWithMedia?.Media?.PrimaryImage?.[0];
    } else {
      const packageEntry = props.data as IPackageResponse;
      return packageEntry?.PrimaryImage?.[0];
    }
  }, [props.isSingle, props.data]);

  return (
    <div className="desktop:max-w-[100%]">
      <div className="h-fit w-full rounded-2xl desktop:flex desktop:h-fit">
        <div className="relative mr-4 aspect-[1/1] w-full desktop:h-[540px] desktop:w-4/6">
          <ImageCDN
            className="rounded-2xl"
            layout="fill"
            src={ImageDefault(mainImage)}
            width="908"
            height="540"
            alt={props.data.Title}
            objectFit="cover"
            priority={false}
          />
        </div>
        <div className="hidden desktop:flex desktop:h-[540px] desktop:w-2/6">
          <PackageDesktopPhotos
            data={props.data}
            isSingle={props.isSingle}
            collectionType={props.collectionType}
          />
        </div>
      </div>
    </div>
  );
}

export default PhotoWithTags;
